"use client"

import Button from "@src/components/Button"
import { trackLandingCta } from "@src/components/LandingPage/landingAnalytics"
import { NearIcon, NearLogoIcon } from "@src/icons"
import clsx from "clsx"
import Link from "next/link"
import { usePathname } from "next/navigation"
import { useLayoutEffect, useState } from "react"
import { LEGAL_ROUTES } from "./legalRoutes"

type ScrollState = "top" | "scrolled" | "past-threshold"

export const MarketingHeader = () => {
  const [scrollState, setScrollState] = useState<ScrollState>("top")
  const pathname = usePathname()
  const isLegal = LEGAL_ROUTES.has(pathname)
  const isHomePage = pathname === "/" || pathname === ""
  const shouldShowButton = !isHomePage || scrollState === "past-threshold"

  useLayoutEffect(() => {
    const handleScroll = () => {
      const y = window.scrollY
      setScrollState(y >= 415 ? "past-threshold" : y > 0 ? "scrolled" : "top")
    }
    handleScroll()
    window.addEventListener("scroll", handleScroll, { passive: true })
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <header
      className={clsx(
        "sticky top-0 z-20 w-full border-b",
        isLegal && "dark:bg-gray-850",
        isLegal && scrollState !== "top" && "dark:border-white/10",
        scrollState === "top"
          ? "border-transparent"
          : "border-black/11 bg-white"
      )}
    >
      <div
        className={clsx(
          "mx-auto flex max-w-7xl items-center justify-between border-x px-6 py-5 sm:px-8",
          isHomePage && scrollState === "top"
            ? "border-transparent xl:border-black/11"
            : "border-transparent"
        )}
      >
        <Link href="/" className="flex items-center gap-3">
          <NearIcon className="size-7 shrink-0" />
          <NearLogoIcon
            className={clsx(
              "h-3.5 shrink-0 text-black",
              isLegal && "dark:text-white"
            )}
          />
          <span className="sr-only">Home</span>
        </Link>
        <div className="flex min-h-8 items-center gap-2">
          <Button
            size="sm"
            variant="transparent"
            href="/login"
            onClick={() => trackLandingCta("header_sign_in")}
          >
            Log in
          </Button>
          {shouldShowButton && (
            <Button
              size="sm"
              href="/home"
              className="fade-in animate-in duration-150"
              onClick={() =>
                trackLandingCta(
                  isHomePage ? "header_create_account" : "header_open_app"
                )
              }
            >
              Create account
            </Button>
          )}
        </div>
      </div>
    </header>
  )
}
